import { get } from 'lodash';
import { activeReport } from './report';

export const activeFilters = () => {
  const filters = localStorage.getItem(`filters_${get(activeReport(), 'id')}`) || '{}';
  return JSON.parse(filters);
};

export default activeFilters;
